import { render } from "./ContactBoxComponent.vue?vue&type=template&id=999ab5ea"
import script from "./ContactBoxComponent.vue?vue&type=script&lang=js"
export * from "./ContactBoxComponent.vue?vue&type=script&lang=js"

import "./ContactBoxComponent.vue?vue&type=style&index=0&id=999ab5ea&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__